<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.tag'),

            filter: {
                title: { value: null, type: 'text'},
                activated: { value:null, type:'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.rejected') },
                        { id: null, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
            },
            filtersDefault: {
                activated: { value:null, type:'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.rejected') },
                        { id: null, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'title', is_sort: true, classes: 'text-l' },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'activated', is_sort: true, classes: 'text-l' },
            ],
            tableBody: {
                //activated: { type: 'boolean' },
                user_id: {
                    type: 'function',
                    function: this.getCountUsers
                },
            },

            apiList: this.$store.getters.getApiUrl('tag'),
            pageRoute: 'tag',
            pageRouteCreate: 'tag.create',
            pageRouteEdit: 'tag.edit',
            pagePermission: 'artifact.tag',

            selectBooleanOptions: [
                { id: false, title: this.$ml.get('interface.rejected') },
                { id: null, title: this.$ml.get('interface.no') },
                { id: true, title: this.$ml.get('interface.yes') },
            ],
        }
    },

    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries
        })
    },
    methods: {
        getCountUsers(item) {
            return item.users.length
        },
        saveItem(item) {
            this.$store.commit('setLoading', true)
            return axios.put(this.$store.getters.getApiUrl('tag', item.id), {
                element: item
            })
            .then(({data}) => {
                if (data.success) {
                    this.$store.commit('setNotification', {
                        type: 'success',
                        message: this.$ml.get('interface.saved')
                    })
                } else {
                    this.$store.commit('setErrorMessage', data.message)
                }
            }).catch((error) => {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: error
                })
            })
            .finally(() => {
                this.$store.commit('setLoading', false)
            })
        },
        // Получить список
        getData() {
            let sort = []
            this.tableHeader.map(item => {
                if (item.is_sort && item.key && item.sort) {
                    sort.push({ key: item.key, sort: item.sort })
                }
            })
            this.$store.commit('setLoading', true)
            axios.get(this.apiList, {
                params: {
                    page: this.page,
                    paginate: this.paginateCount,
                    filter: this.filterSearch,
                    sort: sort
                }
            })
            .then(({data}) => {
                if (data.data.length === 0 && this.page > 1) {
                    this.setPage(data.last_page)
                    return
                }
                this.listItems = data.data.map(item => {
                    if (item.activated === -1) {
                        item.activated = false
                    }
                    if (item.activated === 0) {
                        item.activated = false
                    }
                    if (item.activated === 1) {
                        item.activated = true
                    }
                    return item
                })
                this.last_page = data.last_page
            })
            .finally(() => {
                this.$store.commit('setLoading', false)
            })
        },



    }
}
</script>

<style scoped>

</style>
